module.exports = __webpack_public_path__ + "public/backStage.bd53b3b05e711b20e3a2ad68a399a279.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/backStage.jpg
// module id = 1726
// module chunks = 0